import React from 'react';

import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

function ShortAnswer({
  identifier, pages, info,
  mode, handleDeleteQuestion, handleDuplicateQuestion, setPages,
}) {
  const question = useQuestionForm({
    identifier, pages, info, setPages, writeVia: 'setPages',
  });

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleKey="task.taskEdition.shortAnswerText.question"
      descriptionKey="task.taskEdition.shortAnswerText.description"
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
    />
  );
}

export default ShortAnswer;
